import type { SVGProps } from 'react'
import clsx from 'classnames'

interface IconArrowXAxisIconProps extends SVGProps<SVGSVGElement> {
  direction: 'prev' | 'next'
}

export const ArrowXAxisIcon = ({ className, direction, ...restProps }: IconArrowXAxisIconProps) => {
  return (
    <svg
      className={clsx(className, 'arrow-icon', `arrow-direction-${direction}`)}
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 16 16"
      {...restProps}
    >
      <path
        className="prev"
        d="M10.3222 2.17676L4.77438 7.29782V8.7021L10.3222 13.8232L11.2266 12.8434L6.10771 8.11833V7.88159L11.2266 3.1565L10.3222 2.17676Z"
      />
      <path
        className="next"
        d="M5.67781 2.17676L11.2256 7.29782V8.7021L5.67781 13.8232L4.77344 12.8434L9.89229 8.11833V7.88159L4.77344 3.1565L5.67781 2.17676Z"
      />
    </svg>
  )
}
